export default class SpeakersSlider {

	static getHolderSelectors = () => ['.speakers-slider'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#holderElement.querySelector('.splide');
		const slider = new Splide(this.#holderElement.querySelector('.splide'), {
			arrows: false,
			fixedWidth: '31rem',
			focus: 'center',
			gap: '2.12rem',
			type: 'loop',
			pagination: false,
			breakpoints: {
				576: {
					fixedWidth: 'calc(100vw - 2rem)',
				}
			}
		});
		slider.mount();

		this.#holderElement.querySelectorAll('[data-slider-control]').forEach(button => {
			button.addEventListener('click', () => {
				slider.go(button.dataset.sliderControl);
			});
		});
	}

}
